import Swiper from 'swiper';
import { Pagination, Navigation } from 'swiper/modules';

// Homepage team slider
if (document.getElementById('home-team-slider')) {
     new Swiper("#home-team-slider", {
        slidesPerView: 1.15,
        spaceBetween: 16,
        modules: [Navigation],
        navigation: {
            nextEl: ".swiper__arrow--next",
            prevEl: ".swiper__arrow--prev",
        },
        breakpoints: {
            // when window width is >= 575px
            575: {
                slidesPerView: 2,
            },
            992: {
                slidesPerView: 3,
            },
            1199: {
                slidesPerView: 4,
            }
        }
    });
}

// Home reviews slider
if (document.getElementById('home-reviews-slider')) {
    new Swiper("#home-reviews-slider", {
        slidesPerView: 1.3,
        spaceBetween: 16,
        pagination: {
            el: ".swiper-pagination",
            clickable: true
        },
        modules: [Pagination],
        breakpoints: {
            // when window width is >= 992px
            992: {
                slidesPerView: 2.3,
            }
        }
    });
}

// Specialist team slider
if (document.getElementById('specialist-team-slider')) {
    new Swiper("#specialist-team-slider", {
        slidesPerView: 1.15,
        spaceBetween: 16,
        modules: [Navigation],
        navigation: {
            nextEl: ".swiper__arrow--next",
            prevEl: ".swiper__arrow--prev",
        },
        breakpoints: {
            // when window width is >= 575px
            575: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: 2,
            },
            1200: {
                slidesPerView: 3,
            },
        }
    });
}